module.exports = __webpack_public_path__ + "assets/img/delete.b8361cdc.svg";